export default {"src":"/_next/static/media/quotes.dd565462.svg","height":771,"width":1440,"blurWidth":0,"blurHeight":0};